export default "__VITE_ASSET__CFkSOFaT__"